import React from "react";
import "./Contact.css";

export default function Contact() {
  return (
    <div className="cta-contact">
      <div className="cta-contact__actions">
        {/* ZALO */}
        <a
          href={`sms:0941297219?body=${encodeURIComponent(
            "Xin chào, báo phí rút riền thẻ tín dụng giúp tôi qua zalo: ",
          )}`}
          onClick={() => {
            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({
              event: "goi",
            });
          }}
          className="contact-bubble contact-bubble--sms"
        >
          <span className="contact-bubble__wave"></span>
          <span className="contact-bubble__wave contact-bubble__wave--delay"></span>

          <span className="contact-bubble__ring contact-bubble__ring--1"></span>
          <span className="contact-bubble__ring contact-bubble__ring--2"></span>

          <span className="contact-bubble__core">
            <span className="contact-bubble__zalo-text">SMS</span>
          </span>
        </a>

        {/* CALL */}
        <a
          href="tel:0941297219"
          onClick={() => {
            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({
              event: "sms",
            });
          }}
          className="contact-bubble contact-bubble--call"
        >
          <span className="contact-bubble__wave"></span>
          <span className="contact-bubble__wave contact-bubble__wave--delay"></span>

          <span className="contact-bubble__ring contact-bubble__ring--1"></span>
          <span className="contact-bubble__ring contact-bubble__ring--2"></span>

          <span className="contact-bubble__core contact-bubble__core--call">
            <span className="contact-bubble__label">GỌI NGAY</span>
          </span>
        </a>
      </div>
    </div>
  );
}
